// api地址和请求方法中转

import APIList from './api';
import { HttpRequest } from '@/utils/http';

export const API = APIList;

export const http = new HttpRequest();

export default {
    API,
    http
};
